import { FC, useCallback, useEffect, useState } from 'react';
import {
  Create,
  Loading,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
} from 'react-admin';
import { AiSettingsResponse } from '../../../../shared/api';
import { promptDataProvider } from '../../../../shared/utils/promptDataProvider';
import { SliderInput } from '../../../../entities/SliderInput/ui/SliderInput';
import styles from './styles.module.scss';

export const PromptCreate: FC = () => {
  const [lastPrompt, setLastPrompt] = useState<AiSettingsResponse | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  const getLastPrompt = useCallback(async () => {
    setIsFetching(true);
    const { data } = await promptDataProvider.getList('prompt', {});
    setLastPrompt(data[0] ?? null);
    setIsFetching(false);
  }, []);

  useEffect(() => {
    getLastPrompt();
  }, [getLastPrompt]);

  if (isFetching) {
    return (
      <Create>
        <Loading
          loadingPrimary="Загрузка"
          loadingSecondary="Пожалуйста, подождите"
        />
      </Create>
    );
  }

  return (
    <Create>
      <SimpleForm
        defaultValues={{
          prompt: lastPrompt?.prompt,
          temperature: lastPrompt?.temperature,
        }}
        toolbar={
          <Toolbar>
            <SaveButton label="Сохранить" />
          </Toolbar>
        }
      >
        <TextInput
          label="Промпт"
          variant="outlined"
          multiline
          minRows={4}
          maxRows={6}
          source="prompt"
          fullWidth
          placeholder="Введите текст промпта"
          validate={[required('Обязательно для заполнения')]}
        />
        <SliderInput
          aria-labelledby="prompt-slider"
          valueLabelDisplay="auto"
          step={0.05}
          source="temperature"
          marks
          min={0}
          max={1}
          controlClassName={styles.PromptSlider}
        />
      </SimpleForm>
    </Create>
  );
};
